import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["patientSelect", "form"]

  connect() {
    this.initializePatientSearch()
  }

  initializePatientSearch() {
    if (!this.hasPatientSelectTarget) return

    const select = this.patientSelectTarget
    const options = Array.from(select.options)

    // Create a searchable wrapper
    const wrapper = document.createElement('div')
    wrapper.className = 'position-relative'
    wrapper.style.cssText = 'width: 100%;'

    // Create search input
    const searchInput = document.createElement('input')
    searchInput.type = 'text'
    searchInput.className = 'form-control'
    searchInput.placeholder = 'Buscar paciente...'
    searchInput.autocomplete = 'off'

    // Set initial value if there's a selection
    const selectedOption = select.options[select.selectedIndex]
    if (selectedOption && selectedOption.value) {
      searchInput.value = selectedOption.text
    }

    // Create dropdown
    const dropdown = document.createElement('div')
    dropdown.className = 'position-absolute w-100 d-none'
    dropdown.style.cssText = `
      z-index: 1050;
      max-height: 250px;
      overflow-y: auto;
      background: white;
      border: 1px solid #ced4da;
      border-top: none;
      border-radius: 0 0 4px 4px;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    `

    // Populate dropdown
    const populateDropdown = (filter = '') => {
      dropdown.innerHTML = ''
      const filterLower = filter.toLowerCase()

      options.forEach(opt => {
        if (!opt.value && opt.text.startsWith('--')) {
          // Skip placeholder
          if (!filter) {
            const item = document.createElement('div')
            item.className = 'px-3 py-2 text-muted small'
            item.style.cursor = 'pointer'
            item.textContent = opt.text.replace(/^--\s*/, '').replace(/\s*--$/, '')
            item.dataset.value = ''
            dropdown.appendChild(item)
          }
          return
        }

        if (filterLower && !opt.text.toLowerCase().includes(filterLower)) {
          return
        }

        const item = document.createElement('div')
        item.className = 'px-3 py-2 patient-option'
        item.style.cssText = 'cursor: pointer; transition: background-color 0.15s;'
        item.textContent = opt.text
        item.dataset.value = opt.value

        item.addEventListener('mouseenter', () => {
          item.style.backgroundColor = '#e9f5e9'
        })
        item.addEventListener('mouseleave', () => {
          item.style.backgroundColor = ''
        })

        item.addEventListener('click', () => {
          select.value = opt.value
          searchInput.value = opt.value ? opt.text : ''
          dropdown.classList.add('d-none')
          // Auto-submit the form
          this.submitForm()
        })

        dropdown.appendChild(item)
      })

      if (dropdown.children.length === 0) {
        const noResults = document.createElement('div')
        noResults.className = 'px-3 py-2 text-muted small'
        noResults.textContent = 'No se encontraron pacientes'
        dropdown.appendChild(noResults)
      }
    }

    // Event handlers
    searchInput.addEventListener('focus', () => {
      populateDropdown(searchInput.value)
      dropdown.classList.remove('d-none')
    })

    searchInput.addEventListener('input', (e) => {
      populateDropdown(e.target.value)
      dropdown.classList.remove('d-none')

      // If input is cleared, reset selection
      if (!e.target.value) {
        select.value = ''
      }
    })

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) {
        dropdown.classList.add('d-none')
      }
    })

    // Clear button
    const clearBtn = document.createElement('button')
    clearBtn.type = 'button'
    clearBtn.className = 'btn btn-link position-absolute'
    clearBtn.style.cssText = 'right: 5px; top: 50%; transform: translateY(-50%); padding: 0; color: #999;'
    clearBtn.innerHTML = '<i class="fas fa-times"></i>'
    clearBtn.style.display = selectedOption && selectedOption.value ? 'block' : 'none'

    clearBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      searchInput.value = ''
      select.value = ''
      clearBtn.style.display = 'none'
      this.submitForm()
    })

    searchInput.addEventListener('input', () => {
      clearBtn.style.display = searchInput.value ? 'block' : 'none'
    })

    // Build the structure
    wrapper.appendChild(searchInput)
    wrapper.appendChild(clearBtn)
    wrapper.appendChild(dropdown)

    // Hide original select and insert wrapper
    select.style.display = 'none'
    select.parentNode.insertBefore(wrapper, select)
  }

  submitForm() {
    if (this.hasFormTarget) {
      this.formTarget.submit()
    }
  }

  // Instant filter on select change
  filterChanged() {
    this.submitForm()
  }
}
